import React from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import style from './style.module.scss'
import {Avatar, Col, Row} from "antd";

const mapStateToProps = ({ settings, user }) => ({ settings, user })

const Footer = ({ settings: { isContentMaxWidth, logo, description }, user }) => {
  return (
    <div
      className={classNames(style.footer, {
        [style.footerFullWidth]: !isContentMaxWidth,
      })}
    >
      { user && user.details &&
      <div className={style.inner}>
        <div className="row">
          <div className="col-md-8">
            <p>
              <strong>Partner Pty Ltd</strong>
            </p>
            <br />
            <p className="mb-0">
              Copyright © 2016-{new Date().getFullYear()} Partner Pty Ltd |{' '}
              <a href="https://flarehr.com" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </p>
          </div>
          <div className="col-md-4">
            {/*<div className={style.logo}>*/}
            {/*  <div className={style.logo__letter}>F</div>*/}
            {/*  <div className={style.logo__name}>{logo}</div>*/}
            {/*  <div className={style.logo__descr}>{description}</div>*/}
            {/*</div>*/}
            <Row>
              <Col>
                <Avatar shape="square" size="large" src="/favicon.png" />
              </Col>
              <Col className="ml-1">
                <h6 style={{ lineHeight: '40px', fontWeight: 'bold' }}>Partner</h6>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      }

    </div>
  )
}

export default connect(mapStateToProps)(Footer)
